import DescriptionIcon from "@mui/icons-material/Description";
import { download } from "server/download";
import { settings } from "app";
import { candidateRequests } from "api/candidateApi";
import { Button } from "react-admin";

const ExamProtocolButton = ({ candidacyId, campaignExamId, disabled }) => {
  const getExamProtocol = () => {
    download(
      `${settings.gatewayApi}/${candidateRequests.getCandidacyExamProtocol(candidacyId, campaignExamId)}`,
      `protocol_${candidacyId}_${new Date().toISOString()}.pdf`,
      "GET",
      null,
      true,
    );
  };

  return (
    <Button
      variant="contained"
      startIcon={<DescriptionIcon />}
      onClick={getExamProtocol}
      disabled={disabled}
      label="Бележка за явяване на изпит"
    />
  );
};

export default ExamProtocolButton;
